import React from "react";
import Loader from "../../components/common/Loader";
import Footer from "../../components/home1/Footer";
import Menu from "../../components/innerpage/Menu";
import Navbar from "../../components/home1/Navbar";
//import StartButton from "../../components/home5_residence/StartButton";
import Header from "../../components/innerpage/contact/Header";
import ContactInfo from "../../components/innerpage/contact/ContactInfo";
import Map from "../../components/innerpage/contact/Map";
import ContactForm from "../../components/innerpage/contact/ContactForm";
import { Helmet } from "react-helmet";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "../../seoConfig";

const PAGE_TITLE = "Contact Us | " + SITE_NAME;
const PAGE_DESC =
  "Get in touch with our architecture and interior design studio to discuss your project — reach out for consultations, quotes, or general enquiries.";
const PAGE_PATH = "/innerpages/contact";

function ContactPage() {
  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESC} />
        <link rel="canonical" href={`${SITE_URL}${PAGE_PATH}`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESC} />
        <meta property="og:url" content={`${SITE_URL}${PAGE_PATH}`} />
        <meta property="og:image" content={`${SITE_URL}${DEFAULT_OG_IMAGE}`} />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESC} />
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/navbar-fix.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>
      <body className="inner-pages-style1 contact-pg-style1 contact-page">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <Header />

          <main>
            <ContactInfo />
            <Map />
            <ContactForm />
          </main>
          <Footer />
        </div>
      </body>
    </>
  );
}

export default ContactPage;
